import { useLocation, Link } from "react-router-dom";

import DealerDetailsIcon from "../assets/dealer-details-icon.png";
import DocumentIcon from "../assets/document-icon.png";
import PaymentIcon from "../assets/payment-icon.png";
import SignatureHandIcon from "../assets/signature-hand-icon.png";

import styles from "./DealerOnboardingNavigation.module.css";

export default function DealerOnboardingNavigation() {
  const location = useLocation();
  const activeStageLink = location.pathname;

  const stages = [
    { name: "Dealer Details", icon: DealerDetailsIcon, link: "/dealer-onboarding/dealer-details" },
    { name: "Payment", icon: PaymentIcon, link: "/dealer-onboarding/subscription" },
    { name: "Upload Documents", icon: DocumentIcon, link: "/dealer-onboarding/upload-docs" },
    { name: "Contract", icon: SignatureHandIcon, link: "/dealer-onboarding/contract" },
  ];

  return (
    <div className="container">
      <div className={styles["onboarding-stages-links"]}>
        {stages.map((stage) => (
          <Link
            key={stage.link}
            to={stage.link}
            className={activeStageLink === stage.link ? styles.active : ""}
          >
            <img src={stage.icon} alt={`${stage.name} Icon`} />
            {stage.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
